import React, { useEffect, useMemo, useReducer, useState } from "react";
import moment from "moment";
import PropTypes from "prop-types";
import Joi from "joi";
import { useTranslation } from "react-i18next";
import { InputAdornment } from "@material-ui/core";
import {
  Inputs,
  DatePickerComponent,
  AutocompleteComponent,
} from "../../../../../../Components";
import { MessageConfirmDialog } from "../../../../../../SharedComponents";
import LookupAutocomplete from "../../../../../../Components/Controls/LookupAutocomplete/LookupAutocomplete";
import { DialogActions } from "@material-ui/core";
import {
  CreateVendorAgreementAPI,
  UpdateVendorAgreementAPI,
} from "../../../../../../Services";
import { GetParams, showError, showSuccess } from "../../../../../../Helper";
import { FooterWrapperComponent } from "../../../VendorsUtilities";
import { useKeyGenerator } from "../../../../../../Hooks/keyGenerator";
import { ActivityFilesUploader } from "../../../../../../Components/UploaderActivitieFileComponent/ActivityFilesUploader";
import { PSICommissionTypeEnum } from "../../../../../../Enums";
import { PSICommissionSlabsComponents } from "./AgreementDetailsContentDialog/PSICommissionSlabsComponents";

const reducer = (state, action) => {
  if (action.id === "edit") {
    return {
      ...action.value,
    };
  } else if (action.id === "edit-some") {
    return {
      ...state,
      ...action.value,
    };
  } else if (action.id) {
    return { ...state, [action.id]: action.value };
  }
  return state;
};

export const AgreementDetailsManagementComponents = ({
  parentTranslationPath,
  translationPath,
  className,
  reloadData,
  activeItem,
  onSave,
  onClose,
}) => {
  const { t } = useTranslation(parentTranslationPath);
  const [key, refresh] = useKeyGenerator();
  const [isMissingInfoMSGOpen, setIsMissingInfoMSGOpen] = useState(false);

  const [isLoading, setIsLoading] = useState(false);
  const [deleteSlabs, setDeleteSlabs] = useState(false);
  const [rangeValues, setRangesValues] = useState({
    from: 0,
    to: 0,
    commission: 0,
  });
  const [isSubmitted, setIsSubmitted] = useState(false);
  const [actionValue, setActionValue] = useState(null);
  const defaultState = useMemo(
    () => ({
      vendorId: +GetParams("id"),
      contractStartDate: null,
      contractDuration: null,
      contractExpiryDate: null,
      agreementStatusId: null,
      psiCommission: null,
      remarks: "",
      agreementsStatus: null,
      psiCommissionType: null,
      files: [],
      psiCommission: null,
      psiCommissionSlabs: [],
    }),
    []
  );
  const reducer2 = (selectedValues, action) => {
    if (action.id === "edit") {
      return {
        ...action.value,
      };
    } else if (action.id === "edit-some") {
      return {
        ...selectedValues,
        ...action.value,
      };
    } else if (action.id) {
      return { ...selectedValues, [action.id]: action.value };
    }
    return selectedValues;
  };

  const [selected, setSelected] = useState({
    psiCommissionType: null,
    psiCommissionSlabs: [],
  });

  const [state, dispatch] = useReducer(
    reducer,
    activeItem
      ? {
          ...activeItem,
          agreementsStatus: {
            lookupItemId: activeItem.agreementStatus?.agreementStatusId,
            lookupItemName: activeItem.agreementStatus?.agreementStatusName,
          },
          files: activeItem.documents.map((file) => ({
            ...file,
            uuid: file.fileId,
          })),
          vendorId: +GetParams("id"),
          psiCommissionType: activeItem?.psiCommissionType,
          psiCommissionSlabs: activeItem?.psiCommissionSlabs || [],
        }
      : {
          ...defaultState,
        }
  );

  const schema = Joi.object({
    psiCommissionType: Joi.number()
      .required()
      .messages({
        "number.base": t(`${translationPath}psi_commission_type_is_required`),
        "number.empty": t(`${translationPath}psi_commission_type_is_required`),
        "number.required": t(
          `${translationPath}psi_commission_type_is_required`
        ),
      }),
  })
    .options({
      abortEarly: false,
      allowUnknown: true,
    })
    .validate(state);
  const isValidDate = (date) => moment(date).isValid();

  const clickHandler = async () => {
    try {
      setIsLoading(true);
      setIsSubmitted(true);
      if (!state.contractExpiryDate || !state.contractStartDate) {
        showError(t(`fill_agreement_start_date_and_end_date`));
        return;
      }
      // if(schema.error){
      //    showError(t(`please-fill-all-required-fileds`));
      //    return;

      // }
      state.agreementStatusId = state.agreementsStatus?.lookupItemId;
      const { agreementsStatus, files, ...body } = state;
      body.psiCommissionSlabs = selected?.psiCommissionSlabs
        ? [...selected.psiCommissionSlabs]
        : [];
      body.documents = state.files?.map((file) => ({
        fileId: file.uuid,
        fileName: file.fileName,
      }));
      if (activeItem) {
        await UpdateVendorAgreementAPI(activeItem.vendorAgreementId, body);
        showSuccess(t`agreement_updated_successfully`);
        onSave();
      } else {
        await CreateVendorAgreementAPI(body);
        showSuccess(t`agreement_created_successfully`);
        onSave();
        reloadData();
      }
      dispatch({ value: defaultState, id: "edit" });
      refresh();
    } catch (error) {
      if (error && error?.response?.data?.Message) {
        const messageOne =
          error?.response?.data?.Message.includes("Invalid slab range") &&
          "Invalid_slab_range";
        const messageTwo =
          error?.response?.data?.Message.includes(
            "Missing range detected between"
          ) && "Missing_range_detected_between";

        showError(
          !activeItem
            ? error?.response?.data?.Message.split(":")[1] ||
                (messageOne && "Invalid slab range") ||
                (messageTwo && "Missing range detected between") ||
                t(`${translationPath}add-agreement-faild`)
            : error?.response?.data?.Message.split(":")[1] ||
                (messageOne && "Invalid slab range") ||
                (messageTwo && "Missing range detected between") ||
                t(`${translationPath}edit-agreement-faild`)
        );
      }
    } finally {
      setIsLoading(false);
    }
  };

  useEffect(() => {
    if (activeItem) {
      const newState = {
        ...activeItem,
        agreementsStatus: {
          lookupItemId: activeItem.agreementStatus?.agreementStatusId,
          lookupItemName: activeItem.agreementStatus?.agreementStatusName,
        },
        files: activeItem.documents.map((file) => ({
          ...file,
          uuid: file.fileId,
        })),
        vendorId: +GetParams("id"),
        psiCommissionType: activeItem?.psiCommissionType,
        psiCommissionSlabs: activeItem?.psiCommissionSlabs || [],
      };
      dispatch({ id: "edit", value: newState });
      if (activeItem?.psiCommissionType) {
        setSelected({
          psiCommissionType:
            activeItem.psiCommissionType &&
            [...Object.values(PSICommissionTypeEnum)].find(
              (a) => a.key === activeItem?.psiCommissionType
            ),
          psiCommissionSlabs: activeItem?.psiCommissionSlabs || [],
        });
      }
    } else if (!activeItem) {
      dispatch({ id: "edit", value: { ...defaultState } });
      setSelected({
        psiCommissionType: null,
        psiCommissionSlabs: [],
      });
    }
  }, [activeItem]);

  return (
    <div key={key}>
      <div className={`${className || "px-2 w-50 mb-2 mt-2"}`}>
        <LookupAutocomplete
          lookupName={"VendorAgreementStatus"}
          selectedValues={state.agreementsStatus}
          placeholder={t("select-agreement-status")}
          inputClasses="inputs theme-form-builder"
          label={"agreement-status"}
          parentTranslationPath={parentTranslationPath}
          onChange={(_, newValue) => {
            dispatch({ id: "agreementsStatus", value: newValue });
          }}
          required
        />
      </div>

      <div className={`${className || "px-2 w-50 mb-2 mt-2"}`}>
        <DatePickerComponent
          idRef={"agreementStartDateRef"}
          labelValue={"agreement-start-date"}
          value={
            isValidDate(state.contractStartDate) &&
            moment(state.contractStartDate).format("YYYY-MM-DDTHH:mm:ss")
          }
          onDateChanged={(newValue) => {
            if (state.contractExpiryDate) {
              dispatch({
                id: "edit-some",
                value: {
                  contractStartDate: moment(newValue).format(
                    "YYYY-MM-DDTHH:mm:ss"
                  ),
                  contractDuration: moment(state.contractExpiryDate).diff(
                    moment(newValue),
                    "months"
                  ),
                },
              });
            } else {
              dispatch({
                id: "contractStartDate",
                value: moment(newValue).format("YYYY-MM-DDTHH:mm:ss"),
              });
            }
          }}
          maxDate={
            isValidDate(state.contractExpiryDate) &&
            moment(state.contractExpiryDate).format("YYYY-MM-DDTHH:mm:ss")
          }
          placeholder={"select-agreement-start-date"}
          parentTranslationPath={parentTranslationPath}
        />
      </div>
      <div className={`${className || "px-2 w-50 mb-2 mt-2"}`}>
        <Inputs
          isAttachedInput
          idRef={`agreementDurationMonthsIDRef`}
          labelValue={"agreement-duration-months"}
          value={state.contractDuration}
          type={"number"}
          min={0}
          onInputChanged={(e) => {
            const { value } = e.target;
            dispatch({
              id: "edit-some",
              value: {
                contractExpiryDate: moment(state.contractStartDate).add(
                  +value,
                  "months"
                ),
                contractDuration: +value,
              },
            });
          }}
          inputPlaceholder={"enter-agreement-duration-months"}
          parentTranslationPath={parentTranslationPath}
          isDisabled={!state.contractStartDate}
        />
      </div>
      <div className={`${className || "px-2 w-50  mt-2 mb-2"}`}>
        <DatePickerComponent
          idRef={"AgreementEndDateRef"}
          value={
            isValidDate(state.contractExpiryDate) &&
            moment(state.contractExpiryDate).format("YYYY-MM-DDTHH:mm:ss")
          }
          labelValue={"agreement-end-date"}
          placeholder={"select-agreement-end-date"}
          onDateChanged={(newValue) => {
            dispatch({
              id: "edit-some",
              value: {
                contractExpiryDate: moment(newValue).format(
                  "YYYY-MM-DDTHH:mm:ss"
                ),
                contractDuration: moment(newValue).diff(
                  moment(state.contractStartDate),
                  "months"
                ),
              },
            });
          }}
          parentTranslationPath={parentTranslationPath}
          minDate={moment(state.contractStartDate)}
          isDisabled={!state.contractStartDate}
        />
      </div>
      <div className="mt-2 mb-2">
        <div className={`${className || "px-2 w-50 mb-2 mt-2"}`}>
          <AutocompleteComponent
            key={`psiCommissionType`}
            idRef={`psiCommissionTypeRef`}
            multiple={false}
            selectedValues={selected?.psiCommissionType}
            inputPlaceholder={t("select_psi_commission_type")}
            data={Object.values(PSICommissionTypeEnum)}
            inputClasses="inputs theme-form-builder"
            displayLabel={(option) => (option && option.title) || ""}
            withoutSearchButton
            labelValue={"psi_commission_type"}
            translationPath={translationPath}
            parentTranslationPath={parentTranslationPath}
            onChange={(e, newValue) => {
              setActionValue(newValue);
              if (
                state?.psiCommissionType === PSICommissionTypeEnum.Slab.key &&
                state?.psiCommissionSlabs?.length
              ) {
                setIsMissingInfoMSGOpen(true);
                return;
              }
              const newValueUpdate = {
                ...state,
                psiCommissionType: newValue?.key || null,
                psiCommission: null,
                psiCommissionSlabs: [],
              };
              setSelected({
                ...selected,
                psiCommissionType: newValue,
                psiCommissionSlabs: [],
              });
              dispatch({ id: "edit", value: newValueUpdate });
            }}
          />
        </div>
      </div>
      {state.psiCommissionType === PSICommissionTypeEnum.FixedAmount.key && (
        <div className={`${className || "px-2 w-50 mb-2 mt-2 mt-2"}`}>
          <Inputs
            type={"number"}
            endAdornment={
              <InputAdornment position="start" className="px-2">
                AED
              </InputAdornment>
            }
            withNumberFormat
            labelValue={"fixed_commission"}
            wrapperClasses={"theme-form-builder"}
            parentTranslationPath={parentTranslationPath}
            inputPlaceholder={"enter_fixed_commission"}
            value={state?.psiCommission || ""}
            onInputChanged={(e) => {
              let { value } = e.target;
              if (value < 0) value = value * -1;

              dispatch({ id: "psiCommission", value: e.target.value });
            }}
          />
        </div>
      )}

      {state.psiCommissionType === PSICommissionTypeEnum.Percentage.key && (
        <div className={`${className || "px-2 w-50 mt-2 mb-2"}`}>
          <Inputs
            labelValue={"psi_commission_percentage"}
            wrapperClasses={"theme-form-builder"}
            parentTranslationPath={parentTranslationPath}
            inputPlaceholder={"enter_psi_commission_percentage"}
            value={state?.psiCommission || ""}
            min={0}
            max={100}
            type={"number"}
            onInputChanged={(e) => {
              let { value } = e.target;
              if (value < 0) value = value * -1;
              if (value > 100) value = 100;
              dispatch({ id: "psiCommission", value: value });
            }}
            withNumberFormat
            endAdornment={
              <InputAdornment position="start" className="px-2">
                %
              </InputAdornment>
            }
          />
        </div>
      )}
      {state.psiCommissionType === PSICommissionTypeEnum.Slab.key && (
        <div className={`${className || "px-2 w-50 mt-2 mb-2"}`}>
          <PSICommissionSlabsComponents
            parentTranslationPath={parentTranslationPath}
            translationPath={translationPath}
            state={state}
            selected={selected}
            setSelected={setSelected}
            setRangesValues={setRangesValues}
            rangeValues={rangeValues}
            dispatch={dispatch}
          />
        </div>
      )}
      <div className={`${className || "px-2 w-50 mt-2 mb-2"}`}>
        <Inputs
          multiline
          rows={4}
          labelValue={"remarks"}
          wrapperClasses={"theme-form-builder"}
          parentTranslationPath={parentTranslationPath}
          step={0.1}
          inputPlaceholder={"remarks"}
          value={state.remarks}
          onInputChanged={(e) => {
            dispatch({ id: "remarks", value: e.target.value });
          }}
        />
      </div>
      <div className="py-3">
        <ActivityFilesUploader
          multiple
          accept={
            "application/pdf, image/png, image/jpg, application/vnd.openxmlformats-officedocument.wordprocessingml.document"
          }
          label={t("upload_agreement_document")}
          state={state}
          setState={dispatch}
          // isDisabled={!isEmpty(state.files)}
          // flagAsDeleted={!!activeItem}
          showLoading
        />
      </div>
      {!activeItem ? (
        <DialogActions>
          <FooterWrapperComponent
            parentTranslationPath={parentTranslationPath}
            onClose={onClose}
            onSave={clickHandler}
            disabled={isLoading || !state?.agreementsStatus?.lookupItemId}
          />
        </DialogActions>
      ) : (
        <DialogActions>
          <FooterWrapperComponent
            parentTranslationPath={parentTranslationPath}
            onClose={onClose}
            onSave={clickHandler}
            disabled={isLoading || !state.agreementsStatus?.lookupItemId}
          />
        </DialogActions>
      )}
      {isMissingInfoMSGOpen && (
        <MessageConfirmDialog
          isDialogOpen={isMissingInfoMSGOpen}
          theme="warning"
          content={{
            heading: t`${translationPath}delete_all_slabs`,
            body: t`${translationPath}are_you_sure_to_delete_all_slabs_if_you_change_or_remove_psi_commission_type_slab`,
          }}
          confirmButton={{
            label: t`${translationPath}confirm`,
            handler: () => {
              const newValueUpdate = {
                ...state,
                psiCommissionType: actionValue?.key || null,
                psiCommission: null,
                psiCommissionSlabs: [],
              };
              setSelected({
                ...selected,
                psiCommissionType: actionValue || null,
                psiCommissionSlabs: [],
              });
              dispatch({ id: "edit", value: newValueUpdate });
              setIsMissingInfoMSGOpen(false);
            },
          }}
          cancelButton={{
            label: t`${translationPath}discard`,
            handler: () => {
              const newValueUpdate = {
                ...state,
                psiCommissionType: PSICommissionTypeEnum.Slab.key || null,
                psiCommission: state?.psiCommission,
                psiCommissionSlabs: state?.psiCommissionSlabs,
              };
              setSelected({
                psiCommissionType: PSICommissionTypeEnum.Slab || null,
                psiCommissionSlabs: selected?.psiCommissionSlabs,
              });
              dispatch({ id: "edit", value: newValueUpdate });
              setIsMissingInfoMSGOpen(false);
            },
          }}
          parentTranslationPath={parentTranslationPath}
        />
      )}
    </div>
  );
};
AgreementDetailsManagementComponents.propTypes = {
  parentTranslationPath: PropTypes.string.isRequired,
  state: PropTypes.objectOf(PropTypes.any).isRequired,
  setState: PropTypes.func.isRequired,
  selected: PropTypes.objectOf(PropTypes.any).isRequired,
  setSelected: PropTypes.func.isRequired,
  className: PropTypes.string,
  editForm: PropTypes.bool,
};

AgreementDetailsManagementComponents.defaultProps = {
  editForm: false,
  className: "",
};
